"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_CONSTANTS = void 0;
exports.APP_CONSTANTS = {
    auth: {
        register: "users/register",
        sync: "users/sync",
        login: "auth/login",
        checkUsername: "users/check",
        // profile: "me",
        userProfile: "users/me", // get the user details
        users: "users", // get the user details
        quota: "users/message/count",
        delete: "users/delete",
    },
    character: {
        index: "characters",
        characters: "characters",
        create: "characters/new",
        authorCharacters: "admin/characters/users",
        edit: "characters/edit",
        categories: "characters/categories",
        search: "characters/search?query=",
        generateCharacter: "characters/generate-details",
    },
    conversation: {
        index: "conversations",
        update: "conversations",
    },
    prompts: {
        get: "admin/prompts?limit=100&offset=0&globalFilter=&sorting=[]&filters=[]",
        upload: "prompts",
        update: "prompts/update-prompt",
    },
    messeges: {
        send: "messages/send",
        images: "messages/images",
        get: "messages",
    },
    purchases: {
        plans: 'subscription-plan',
        checkout: 'users/subscribe',
    },
    discover: {
        configs: "admin/discover",
        categories: "categories",
        stats: 'messages/messages-count',
        characters: {
            popular: 'character-metadata',
            editor: 'character-metadata',
            users: 'admin/characters/users'
        },
        collections: 'collections',
        journeys: 'journeys',
        collectioByTitle: 'collections/title',
        gptModels: 'gpt-models'
        //https://mppuhfazgw.us-west-2.awsapprunner.com/api/v1/messages/messages-count
    },
    imageModel: 'image-models',
    constants: {
        'scrap': 'constants/web-scraper', // Endpoint for web scraping functionality
        webSearch: (query) => `https://nodejs-serverless-function-express-five-sepia.vercel.app/api/search?q=${query}`, // Endpoint for web search functionality
    },
    documents: {
        index: 'files',
        summaryJson: 'constants/doc-summary-json',
        createSummary: 'files/generate-openai-summary',
        createSummaryAssistant: 'files/generate-assistant-summary', // Replace /generate-summary to use normal open ai
        attachFiles: 'files/attach-files',
        share: 'share',
        shareDetails: 'share/details',
        follow: 'share/follow-up',
        regenerateImage: 'files/images',
        generateAudio: 'files/audio',
        podcastfy: 'files/create-podcast',
        transcript: 'files/transcript',
        notes: 'notes',
        notesTemplate: 'notes/template',
        title: 'files/update-title',
        search: (query) => `files/search?q=${query}`,
    },
    audio: {
        speech: 'speech/text-to-speech', // OpenAI speech synthesis endpoint
    },
};
